import React from "react";
import { Grid, Typography } from "@mui/material";
import Images from "../../config/images";
import useStyles from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../../redux/reducers/auth/actions";
import { path } from "slate";

function Footer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname } = location;
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);
  const { clearAllData } = authActions;

  const disabledFooter =
    [
      "/contractor-profile",
      "/",
      "/dashboard",
      "/create-proposal",
      "/manage-project",
      "/ongoing-project",
      "/create-profile",
      "/request-proposal",
      "/balance-breakdown",
      "/payments",
      "/user-management",
      "/chat",
      "/account-setting",
      "/account-setting/users",
      "/contractor-documents",
      "/designer-documents",
      "/supplier-documents",
      "/create-package",
      "/edit-package",
      "/packages",
      "/proposals",
      "/billing",
      "/login",
      "/signup",
      "/user-login",
      "/forgot-password",
      "/reset-password",
      "/new-create-proposal",
      "/otp-verify",
      "/role",
      "/rfqs",
      "/edit-profile-form",
      "/contractor/proposals",
      "/contractor/proposal/new",
      "/customers",
      "/conversation",
      "/contractor-billing"
    ].some((path) => pathname === path) ||
    pathname.startsWith("/project/details/") ||
    pathname.startsWith("/proposal/details/") ||
    pathname.startsWith("/new-create-proposal") ||
    pathname.startsWith("/package/details/") ||
    pathname.startsWith("/rfq/pricing/") ||
    pathname.startsWith("/rfq/design-pricing/") ||
    pathname.startsWith("/contractor/proposal/") ||
    pathname.startsWith("/new-create-package");

  const handleDragStart = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {disabledFooter ? null : (
        <div className={classes.footerMainCon}>
          <Grid container className={classes.container}>
            <Grid
              container
              item
              xs={10}
              sm={10}
              md={10}
              display="flex"
              alignItems="center"
            >
              <Grid
                item
                onDragStart={handleDragStart}
                className={classes.topLeft}
              >
                {/* <img
                  src={
                    pathname === "/signup" || (pathname === "/login" && sm)
                      ? Images.header_logo
                      : Images.header_logo
                  }
                  alt="logoimage"
                  className={classes.imgStyle}
                  onClick={() => {
                    if (
                      userData?.is_email_verified === false ||
                      userData?.contractor_data?.is_email_verified === false
                    ) {
                      dispatch(clearAllData());
                      navigate("/login");
                      return;
                    }

                    if (
                      userData?.contractor_data?.profile_completed === "pending"
                    ) {
                      dispatch(clearAllData());
                      navigate("/login");
                      return;
                    }

                    navigate("/dashboard");
                  }}
                /> */}
              </Grid>
              <Grid item>
                <Typography
                  className={classes.footerTextStyle}
                  sx={{ color: pathname === "/signup" ? "#646F86" : "#FFFFFF" }}
                >
                  Copyright ⓒ 2023. All Rights Reserved by Reno. Version 1.0
                </Typography>
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={2}
              sm={2}
              md={2}
              display="flex"
              alignItems="center"
              justifyContent={"flex-end"}
              className={classes.top}
              paddingRight="2vw"
            >
              {/* <Grid item xs={4} sm={1} md={1} lg={1}>
                <img
                  src={Images.globe}
                  alt="globe"
                  className={classes.imgStyleLanguage}
                />
              </Grid> */}
              {/* <Grid item xs={6} sm={5} md={4} lg={3}>
                <Typography className={classes.language}>ENG</Typography>
              </Grid> */}
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
}

export default Footer;
